module.exports = __webpack_public_path__ + "img/mate-card_tokarev.3e2d493.png";